import translations from '../../translations';
import { isNullOrEmpty } from '../../utils/guard';
import CopyableText from './CopyableText';

interface Props {
    traceId: string | null | undefined;
}

/**
 * Shows the trace ID of a failed engine API request, so users can quote it when reporting the error.
 * Currently we use New Relic but the same mechanism will be used if this is changed later.
 */
const ErrorTraceId = ({ traceId }: Props) => {
    if (isNullOrEmpty(traceId)) {
        return null;
    }

    return (
        <CopyableText
            wrapperClassName="error-trace-id"
            labelText={translations.NOTIFICATION_trace_id_label}
            copyableText={traceId}
            hasCopyButton
        />
    );
};

export default ErrorTraceId;
